import React from 'react';
import { Row, Col, Button, Input, Form, Upload, Typography } from 'antd';
import { MailOutlined, PhoneOutlined, FolderOpenOutlined } from '@ant-design/icons';

import location from '../../../assets/icons/location/01.svg';
import imageIcon from '../../../assets/icons/image/01.svg';

export default function MainInformation(props) {
    return (
        <Row className='mb-35' gutter={20}>
            <Col span={24} className='mb-25'>
                <Typography.Title level={5} className='mt-0'>
                    Información Principal
                </Typography.Title>
            </Col>
            <Col span={24}>
                <Form.Item
                    label="Razón social / Nombres y Apellidos"
                    name="businessName"
                    className='input-material'
                    rules={[{ required: true, message: 'Campo obligatorio.' }]}
                >
                    <Input
                        size='large'
                        prefix={<></>}
                        placeholder="Ingresar razón social"
                        autoComplete="off"
                    />
                </Form.Item>
            </Col>
            <Col span={24}>
                <Form.Item
                    label="Descripción"
                    name="description"
                    className='input-material'
                >
                    <Input.TextArea
                        placeholder="Ingresar descripción . . ."
                        autoComplete="off"
                        rows={4}
                    />
                </Form.Item>
            </Col>
            <Col span={12}>
                <Form.Item
                    label="Teléfono"
                    name="phone"
                    className='input-material'
                >
                    <Input
                        size='large'
                        prefix={<PhoneOutlined rotate={90} className='mr-3' style={{ fontSize: 18 }} />}
                        placeholder="Ingresar teléfono"
                        autoComplete="off"
                    />
                </Form.Item>
            </Col>
            <Col span={12}>
                <Form.Item
                    label="Correo"
                    name="email"
                    className='input-material'
                >
                    <Input
                        size='large'
                        prefix={<MailOutlined className='mr-3' style={{ fontSize: 18 }} />}
                        placeholder="Ingresar correo"
                        autoComplete="off"
                    />
                </Form.Item>
            </Col>
            <Col span={24}>
                <Form.Item
                    label="Ubicación"
                    name="location"
                    className='input-material'
                >
                    <Input
                        size='large'
                        prefix={<img className='mr-3' style={{ height: 18 }} src={location} alt='...' />}
                        placeholder="Ingresar ubicación"
                        autoComplete="off"
                    />
                </Form.Item>
            </Col>
            <Col span={24}>
                <div className='catalog-card-content'>
                    <div className='catalog-card-item'>
                        <div className="vertical-center h-100">
                            <img src={props.file === undefined ? imageIcon : props.file.stringBase64 ?? props.file.url} alt="card" />
                        </div>
                    </div>
                    <div className='catalog-card-info'>
                        <div className="flex-parent">
                            <div className="flex-child long-and-truncated">
                                <div className='ml-5' style={{ whiteSpace: 'normal' }}>
                                    *.png *.jpg *.jpeg *.gif *.tiff *.svg *.webp
                                </div>
                            </div>
                            <div className="flex-child short-and-fixed">
                                <div className='mt-5'>
                                    <Upload
                                        multiple={false}
                                        showUploadList={false}
                                        beforeUpload={props.onBefore}
                                    >
                                        <Button
                                            type="text"
                                            shape='round'
                                            icon={<FolderOpenOutlined />}
                                        >
                                            Subir Imagen
                                        </Button>
                                    </Upload>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Col>
        </Row>
    )
}